import React from 'react';
import './modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const confirmModal = ({
  isOpen,
  closeModal,
  onConfirm,
  icon,
  mainMessage,
  secondaryMessage,
  children,
  loading = false,
  // Aviso simples (um botão só, ex.: "Entendi"): confirmLabel troca o texto e showCancel={false} esconde o Cancelar.
  confirmLabel = 'Confirmar',
  showCancel = true,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <div className="confirm-modal-header">
          <FontAwesomeIcon icon={icon || faExclamationTriangle} className="confirm-modal-icon" />
        </div>
        <div className="confirm-modal-body">
          <h2>{mainMessage}</h2>
          <p>{secondaryMessage}</p>
          {children}
        </div>
        <div className="confirm-modal-footer">
          <button
            className="confirm-button"
            onClick={onConfirm}
            disabled={loading}
            style={{ opacity: loading ? 0.6 : 1 }}
          >
            {loading ? 'Processando...' : confirmLabel}
          </button>
          {showCancel && (
            <button className="cancel-button" onClick={closeModal}>Cancelar</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default confirmModal;
